<template>
  <div class="column">
    <div class="row justify-end">
      <div class="col col-auto q-pa-sm q-gutter-sm">
        <q-btn color="process" size="sm" outline @click.native="exportList('action')">{{$t('processes.export_action')}}</q-btn>
      </div>
      <div class="col col-auto q-pa-sm q-gutter-sm">
        <q-btn color="process" size="sm" outline @click.native="exportList()">{{$t('processes.export')}}</q-btn>
      </div>
      <div class="col col-auto q-pa-sm q-gutter-sm">
        <q-btn color="process" size="sm" :to="{ name: 'suivi-des-protocoles-form' }" icon-right="add_circle">{{$t('processes.create_suivi')}}</q-btn>
      </div>
    </div>
    <q-table flat wrap-cells
      :data="agenceRougeProcesses"
      :columns="columns"
      row-key="id"
      :rows-per-page-options="rowsPerPageOptions"
      :pagination.sync="pagination"
      :loading="loading"
      :filter="filter"
      @request="onRequest"
      binary-state-sort>
      <q-tr slot="body" slot-scope="props" :props="props"
        @click.native="$router.push({ name: 'suivi-des-protocoles-form', params: { id: props.row.id } })"
        class="cursor-pointer">
        <q-td v-for="col in props.cols" :key="col.name" :props="props" :auto-width="col.autoWidth">
          <div v-if="col.value" v-html="col.value" />
        </q-td>
      </q-tr>
    </q-table>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import download from 'downloadjs'

export default {
  name: 'SuiviDesDelegationsList',

  preFetch ({ store, currentRoute, previousRoute, redirect, ssrContext }) {
    store.dispatch('processes/fetchFilters', 'agenceRouge')
  },

  meta () {
    return {
      title: 'Suivi des protocoles et agence rouge'
    }
  },

  data () {
    return {
      loading: false
    }
  },

  computed: {
    ...mapGetters({
      agenceRougeProcesses: 'processes/getProcesses',
      filters: 'processes/getFilters',
      rowsPerPageOptions: 'config/getRowsPerPageOptions'
    }),
    pagination: {
      ...mapGetters({ get: 'processes/getPagination' }),
      ...mapMutations({ set: 'processes/setPagination' })
    },
    filter () {
      return this.$route.meta.filter
    },

    columns () {
      console.log(this.agenceRougeProcesses, this.filters)
      if (this.agenceRougeProcesses.length === 0) return []
      else {
        const fields = ['entities', 'type_process', 'date_entree_dans_process', 'date_previsionnelle_sortie_process', 'statut']
        const sortable = ['entities', 'date_entree_dans_process', 'date_previsionnelle_sortie_process']

        return fields.map(key => {
          let label = this.$t(`processes.fields.${key}.label`)
          let align = 'left'
          let autoWidth = false
          let formatFn = val => val

          if (key === 'entities') {
            label = this.$t(`processes.fields.entity.label`)
            formatFn = val => val ? val.map(entity => `${entity['label']}`).join(', ') : ''
          } else if (key === 'type_process') {
            label = this.$t(`processes.fields.type.label`)
          } else if (key === 'date_entree_dans_process' || key === 'date_previsionnelle_sortie_process') {
            formatFn = val => this.$formatDate(val)
          } else if (key === 'statut') {
            formatFn = val => val ? this.$t(`processes.status.${val}`) : ''
            align = 'center'
          }

          return {
            name: key,
            align: align,
            label: label,
            field: key,
            format: formatFn,
            sortable: sortable.indexOf(key) >= 0,
            autoWidth: autoWidth
          }
        })
      }
    }
  },

  watch: {
    filters: {
      handler (newVal, oldVal) {
        console.log('"watch filters"')
        this.onRequest({ pagination: this.pagination })
      },
      deep: true
    },
    '$route.meta.filter': {
      handler (newVal, oldVal) {
        console.log('"watch $route.meta.filter"')
        this.onRequest({ pagination: this.pagination })
      },
      deep: true
    }
  },

  mounted () {
    if (this.filters) {
      this.onRequest({ pagination: this.pagination })
    }
    this.$store.commit('pages/setBreadcrumbs', [
      { label: this.$t('global.home'), to: { name: 'home' }, icon: 'home' },
      { label: this.$t('processes.processAgence'), to: { name: '' } },
      { label: this.$t('processes.title.suivi_des_protocoles'), to: { name: 'suivi-des-protocoles-en-cours' } },
      {}
    ])

    this.$store.commit('pages/setPageTitle', this.$t('processes.title.suivi_des_protocoles'))
    this.$store.commit('pages/setTabs', [
      { name: 'suivi-des-protocoles-en-cours', label: 'En cours', to: { name: 'suivi-des-protocoles-en-cours' } },
      { name: 'suivi-des-protocoles-archivés', label: 'Archivés', to: { name: 'suivi-des-protocoles-archives' } }
    ])
  },

  methods: {
    onRequest ({ pagination, filter }) {
      this.$store.commit('processes/setPagination', pagination)
      this.loading = true

      let params = { ...pagination, filter: this.filter, typeProcess: 'agenceRouge' }
      if (this.filters) this.filters.forEach(filter => { params[filter.id] = filter.value })

      console.log(params)
      this.$store.dispatch('processes/fetchProcesses', params)
        .finally(() => { this.loading = false })
    },

    exportList (process) {
      let toExport = process || 'agenceRouge'
      this.$axios.get(`/api/processAgences/${toExport}/export`, {
        responseType: 'arraybuffer',
        headers: { 'Content-Type': 'text/csv' }
      }).then(response => {
        download(response.data, `${toExport}.csv`)
      }).catch(this.$notifyError)
    }
  }
}
</script>
